import { H1 } from "@sellar-io/components";

export const RetailerHome = () => (
  <div className="w-full py-4">
    <H1>Home</H1>
  </div>
);
